export function getBaseUrlWithHttp() {
  if (globalThis.location.hostname === 'localhost') return 'http://localhost:8080';

  return 'https://' + globalThis.location.host;
}
